import { FolderIdentity } from '@app/core/model/folder-identity'
import { Type } from 'class-transformer'
import { User } from '@app/core/model/user.model'

export class FolderOverview {
  id: number
  name: string
  description: string
  createdTs: string
  updatedTs: string
  @Type(() => User) createdBy: User
  @Type(() => User) updatedBy: User
  @Type(() => FolderIdentity) identity: FolderIdentity
}
